export default __webpack_public_path__ + "static/media/toggle-icon.ba54e8a9.svg";